import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import DebouncedText from "components/DebouncedText";
import { FC, useEffect, useState } from "react";
import { useFetcher } from "react-router-dom";
import { useFetcherWithSnackbar } from "routes/lens-editor/page-labels/useFetcherWithSnackbar";
import { useNavigate } from "react-router";

interface NewPageLabelDialogProps {
  lensId: number;
  open: boolean;
  close: () => void;
}

const NewPageLabelDialog: FC<NewPageLabelDialogProps> = ({ lensId, open, close }) => {
  const [name, setName] = useState<string>("");
  const [preventsLensHits, setPreventLensHits] = useState<boolean>(false);
  const [triggersFormExtraction, setTriggersFormExtraction] = useState(false);
  const [triggersTableExtraction, setTriggersTableExtraction] = useState(false);
  const canSave = name.length > 0;
  const navigate = useNavigate();
  const fetcher = useFetcher();
  const fetcherResponse = useFetcherWithSnackbar(fetcher, "Page Label created", "Unable to create Page Label");

  const newPageLabel = () => {
    fetcher.submit(
      {
        newPageLabel: {
          name,
          preventsLensHits,
          triggersFormExtraction,
          triggersTableExtraction,
        },
        intent: "create",
      },
      {
        encType: "application/json",
        method: "POST",
        action: `/lens-editor/${lensId}/page-labels`,
      }
    );
  };

  useEffect(() => {
    if (fetcherResponse.completed) {
      navigate(`/lens-editor/${lensId}/page-labels/list/${fetcher.data.id}`);
      close();
    }
  }, [fetcherResponse.completed, fetcher.data]);

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>New Page Label</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <FormControl fullWidth>
            <DebouncedText value={name} onChange={setName} label="Name" />
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={preventsLensHits}
                onChange={(event) => {
                  setPreventLensHits(event.target.checked);
                }}
              />
            }
            label="Prevents Lens Hits"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={triggersFormExtraction}
                onChange={(event) => {
                  setTriggersFormExtraction(event.target.checked);
                }}
              />
            }
            label="Triggers Form Extraction"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={triggersTableExtraction}
                onChange={(event) => {
                  setTriggersTableExtraction(event.target.checked);
                }}
              />
            }
            label="Triggers Table Extraction"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={close}>
          Cancel
        </Button>
        <Button disabled={!canSave} color="primary" variant="contained" onClick={newPageLabel}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewPageLabelDialog;
